const itemsInHead = [
    'resourceHints',
    'seoTags',
    'stylesheets',
    'styleTags',
    'scripts',
    'inlineScripts',
];

const itemsInBody = ['bodyContent'];

const flatten = <T>(arr: T[][]) =>
    arr.reduce(
        (previous: T[], current) =>
            previous.concat(Array.isArray(current) ? current : [current]),
        [],
    );

const transform = <T>(data: {
    url: string;
    extracted: Record<string, T[]>;
}) => ({
    url: data.url,
    head: flatten(itemsInHead.map(i => data.extracted[i])),
    body: flatten(itemsInBody.map(i => data.extracted[i])),
});

export { transform };
